app.filter('cryptoCurrency', ['Utils', 'Storage', 'constants', '$filter',
    function(Utils, Storage, Const, $filter) {

        var isCryptoCurrency = function (currencyCode) {
            var currencies = Storage.get('currencies') || [];

            return currencies.find(function (item) {
                return item.currency.toLowerCase() === currencyCode.toLowerCase() && item.crypto === "1"
            });
        };

        return function(value, currencyCode, fractionSize) {
            var currencySymbol = Const.currencySymbols[currencyCode] || currencyCode || '';

            if (currencyCode && isCryptoCurrency(currencyCode)) {
                var amount = Utils.decimalRound(value, fractionSize || 2);
                return $filter('currency')(amount, currencySymbol, fractionSize || 2);
            }

            // if (Const['cryptoBaseCurrencies'] && Const['cryptoBaseCurrencies'].indexOf(currencyCode) === -1) {
            //     return $filter('currency')(value, currencySymbol, 2);
            // }

            if (Const['cryptoBaseCurrencies'] && Const['cryptoBaseCurrencies'].indexOf(currencyCode) > -1) {
                return $filter('currency')(value, currencySymbol, 5);
            }

            var amount = Utils.decimalRound(value, fractionSize || 2);
            return $filter('currency')(amount, currencySymbol, fractionSize || 2);
        }
}]);
